import React, { Component } from 'react'
import PropTypes from 'prop-types'

import font from './styleReact.css'
import additionals from './additionals.css'

export default class FontIcon extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired, /* nome do icone - nomes em style.css ou demo.html */
        circle: PropTypes.bool,
        size: PropTypes.number,
        color: PropTypes.string
    }

    static defaultProps = {
        circle: false
    }

    render() {
        const { name, circle, style, size, color, ...props } = this.props
        return (
            <i
            {...props}
            className={`
                ${font['icon']}
                ${font['icon-'+name]}
                ${additionals[circle ? 'circle' : '']}
                `}
            style={{
                ...style,
                fontSize: size ? `${size/10}rem` : '',
                color: color,
                borderColor: color,
            }} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/FontIcon/index.js